import { render } from "./ErrorModel.vue?vue&type=template&id=32d45d5e&scoped=true"
import script from "./ErrorModel.vue?vue&type=script&lang=js"
export * from "./ErrorModel.vue?vue&type=script&lang=js"

import "./ErrorModel.vue?vue&type=style&index=0&id=32d45d5e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d45d5e"]])

export default __exports__